// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1hTuG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3aRvI"};